<template>
  <div ref="scrollRef">
    <div class="audio-containter">
      <slot></slot>
    </div>
  </div>
</template>


<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { onIntersect } from "@/components/composables/onIntersect";

const observer = ref({});
const scrollRef = ref({});

const props = defineProps({
  onEnter: {
    type: Function
  },
  onExit: {
    type: Function
  },
  index: {
    type: Number
  }
});

const onEnter = () => {
  props.onEnter(props.index);
};

const onExit = () => {
  props.onExit(props.index);
};

// When the component is mounted, start observing
onMounted(() => {
  observer.value = onIntersect(scrollRef.value, onEnter, onExit, false, {
    threshold: 0.3,
  });
});

// When the component is removed, disconnect the observer (clean-up step)
onUnmounted(() => {
  observer.value.disconnect();
});
</script>

<style lang="scss">

</style>